// External Dependencies:
import { browserHistory } from 'react-router'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import Cookies from 'js-cookie'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

// Events:
const eventPageUpdated = document.createEvent( 'Event' )
eventPageUpdated.initEvent( 'dkePageUpdated', true, true )

export function requestPage( type, slug, requestOnly ) {
	return {
		type: 'REQUEST_PAGE_DATA',
		payload: {
			type: type,
			slug: slug,
			requestOnly: requestOnly
		}
	}
}

export function receivePage( type, subType, slug, json ) {
	return {
		type: 'RECEIVE_PAGE_DATA',
		payload: {
			type: type,
			subType: subType,
			slug: slug,
			data: json
		}
	}
}

export function receivePartialPage( slug, json, dkePageData = false ) {
	return {
		type: 'RECEIVE_PARTIAL_PAGE_DATA',
		payload: {
			slug: slug,
			data: json,
			dkePageData: dkePageData
		}
	}
}

export function receivePageError( json ) {
	return {
		type: 'RECEIVE_PAGE_ERROR',
		payload: json
	}
}

export function setCurrentPage( type, slug ) {
	return {
		type: 'SET_CURRENT_PAGE',
		payload: {
			type: type,
			slug: slug
		}
	}
}

export function appendPage( slug ) {
	return {
		type: 'APPEND_PAGE',
		payload: slug
	}
}

export function setCurrentlyViewedPage( slug, match ) {
	const url = match.path.replace( /(:slug)/g, slug )

	// Update url:
	window.history.pushState( null, null, url )

	return {
		type: 'SET_CURRENTLY_VIEWED_PAGE',
		payload: slug
	}
}

export function getPageData( {
	type = 'page',
	subType = '',
	isArchive = false,
	slug = '',
	categorySlug = '',
	year = '',
	month = '',
	archivePageNumber = false,
	skip = 0,
	number = 1,
	requestOnly = false,
	force = false,
	forceUpdatePostSets = false,
	append = false
} = {} ) {
	return function( dispatch, getState ) {
		if ( siteData.site_is_protected ) {
			return
		}

		const { byId, archiveCategoriesById, loadingById } = getState().page
		const { userIsLoggedIn, wpRestNonce } = getState().site
		const theSubType = subType ? `-${subType}` : ''

		// Get slug:
		if ( ! slug && categorySlug ) {
			slug = categorySlug
		}

		// Normalise slug, removing /:
		slug = slug ? slug.replace( /\//g, '' ) : false
		categorySlug = categorySlug ? categorySlug.replace( /\//g, '' ) : false

		// Get id:
		const theById = isArchive ? archiveCategoriesById : byId
		const theId = type ?`id_${type}_${slug}` : `id_${slug}`

		// Don't load the same thing simultaneously:
		if ( ! isArchive && loadingById[ theId ] ) {
			return
		}

		// force = false

		// Short circuit for existing data (unless logged in):
		if ( ! force && ! userIsLoggedIn && theById[ theId ] ) {
			if ( ! requestOnly ) {
				dispatch( receivePage( slug, theById[ theId ] ) )
			}

			if ( ! append && ! requestOnly ) {
				dispatch( setCurrentPage( type, slug ) )
			}

			return
		}

		dispatch( requestPage( type, 'id_' + slug, requestOnly ) )

		if ( ! requestOnly ) {
			dispatch( showLoading() )
		}

		let url = `${siteData.api_base_url}${type}${theSubType}/?slug=${slug}&category_slug=${categorySlug}&year=${year}&month=${month}&page_number=${archivePageNumber}&skip=${skip}&number=${number}`

		let pagePassword = Cookies.get( `${type}_password_${slug}` )

		if ( pagePassword ) {
			url += `&page_password=${pagePassword}`
		}

		let headers = wpRestNonce ? {
			'X-WP-Nonce': wpRestNonce
		} : {}

		return doRequest( url, {
			credentials: 'include',
			headers: headers
		} )
			.then( json => {
				dispatch( receivePage( type, subType, slug, json ) )

				if ( ! requestOnly ) {
					dispatch( hideLoading() )
				}

				if ( ! append && ! requestOnly ) {
					dispatch( setCurrentPage( type, slug ) )
				}

				if ( append ) {
					dispatch( appendPage( slug ) )
				}

				if ( forceUpdatePostSets || ( ! append && ! requestOnly ) ) {
					dispatch( maybeUpdatePostSets( true ) )
				} else if ( ! append ) {
					dispatch( maybeUpdatePostSets() )
				}

				setTimeout( () => {
					window.dispatchEvent( eventPageUpdated )
				}, 200 )
			} )
			.catch( error => {
				console.log( error, 'error' );
			} )
	}
}

export function getPartialPageData( data ) {
	return function( dispatch, getState ) {
		const { loadingById, selected } = getState().page
		const { userIsLoggedIn, wpRestNonce } = getState().site

		// Normalise slug, removing /:
		const slug = selected.slug ? selected.slug.replace( /\//g, '' ) : false

		if ( ! slug ) {
			return
		}

		// Don't load the same thing simultaneously:
		if ( loadingById[ 'id_' + slug ] ) {
			return
		}

		dispatch( showLoading() )

		const url = `${siteData.api_base_url}partial/?post_id=${data.post_id}&partial_id=${data.screens_id}`
		let headers = wpRestNonce ? {
			'X-WP-Nonce': wpRestNonce
		} : {}

		return doRequest( url, {
			credentials: 'include',
			headers: headers
		} )
			.then( json => {
				dispatch( receivePartialPage( slug, json ) )

				setTimeout( () => {
					window.dispatchEvent( eventPageUpdated )

					setTimeout( () => {
						dispatch( hideLoading() )
					}, 500 )
				}, 200 )
			} )
			.catch( error => {
				console.log( error, 'error' );
			} )
	}
}

export function getFilteredActivities( filters ) {
	return function( dispatch, getState ) {
		const { search, theme, min_time, max_time, min_group_size, max_group_size, age } = filters

		if ( ! search && ! theme && ! min_time && ! max_time && ! min_group_size && ! max_group_size && ! age ) {
			dispatch( clearFilteredActivities() )

			return
		}

		doRequest( `${siteData.api_base_url}activities-search/?search=${search}&theme=${theme}&min_time=${min_time}&max_time=${max_time}&min_group_size=${min_group_size}&max_group_size=${max_group_size}&age=${age}` )
			.then( json => {
				dispatch( receiveFilteredActivities( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveFilteredActivities( data ) {
	return {
		type: 'RECEIVE_FILTERED_ACTIVITIES',
		payload: data
	}
}

export function clearFilteredActivities() {
	return {
		type: 'CLEAR_FILTERED_ACTIVITIES'
	}
}

/**
 * Archives
 */

export function maybeUpdatePostSets( forceUpdate = false ) {
	return {
		type: 'MAYBE_UPDATE_POST_SETS',
		payload: {
			forceUpdate: forceUpdate
		}
	}
}

export function setArchiveDate( year = false, month = false ) {
	return function( dispatch, getState ) {
		dispatch( setArchiveDateDo( year, month ) )
		dispatch( loadMorePosts() )
	}
}

export function setArchiveDateDo( year = false, month = false ) {
	return {
		type: 'SET_ARCHIVE_DATE',
		payload: {
			year: year,
			month: month
		}
	}
}

export function loadMorePosts( subType = 'posts' ) {
	return function( dispatch, getState ) {
		const { selectedArchive, postsSetA, postsSetZ, selectedDateYear, selectedDateMonth } = getState().page
		const slug = selectedArchive.slug
		const skipNumber = postsSetA.length + postsSetZ.length

		if ( 'posts-category' == subType ) {
			subType = 'posts'
		}

		dispatch(
			getPageData( {
				type: 'more',
				subType: subType,
				categorySlug: slug,
				year: selectedDateYear,
				month: selectedDateMonth,
				number: 20,
				skip: skipNumber,
				requestOnly: true,
				force: true,
				forceUpdatePostSets: true
			} )
		)
	}
}

/**
 * Featured image
 */

export function getFeaturedImage() {
	return function( dispatch, getState ) {
		const { selected, selectedArchive } = getState().page
		let page

		if ( selectedArchive ) {
			page = selectedArchive
		} else {
			page = selected
		}

		const slug = page.slug ? page.slug.replace( /\//g, '' ) : false

		if ( ! slug ) {
			return
		}

		if ( ! page.id ) {
			return
		}

		let url = `${siteData.api_base_url}featured-image/?id=${page.id}&v=${siteData.version}`

		if ( page.taxonomy ) {
			url += `&taxonomy=${page.taxonomy}`
		}

		return doRequest( url )
			.then( json => {
				dispatch( receivePartialPage(
					slug,
					{
						featured_image: json
					},
					{
						featured_image_id: json.id
					}
				) )

				setTimeout( () => {
					window.dispatchEvent( eventPageUpdated )
				}, 200 )
			} )
			.catch( error => {

			} )
	}
}

/**
 * Images
 */

export function receiveDkeSectionImageUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_IMAGE_UPDATED',
		payload: data
	}
}

/**
 * Image galleries
 */

export function receiveDkeSectionImageGalleryUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_IMAGE_GALLERY_UPDATED',
		payload: data
	}
}

/**
 * Links
 */

export function receiveDkeSectionLinkUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_LINK_UPDATED',
		payload: data
	}
}

/**
 * Forms
 */

export function receiveDkeSectionFormUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_FORM_UPDATED',
		payload: data
	}
}

/**
 * Maps
 */

export function receiveDkeSectionMapUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_MAP_UPDATED',
		payload: data
	}
}

/**
 * Sections
 */

export function receiveDkeSectionDataUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_DATA_UPDATED',
		payload: data
	}
}

export function receiveDkeSectionAdded( id, data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_ADDED',
		payload: {
			id,
			data
		}
	}
}

export function receiveDkeSectionRemoved( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_REMOVED',
		payload: data
	}
}

export function receiveDkeSectionsReordered( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_REORDERED',
		payload: data
	}
}

export function receiveDkeSectionSettings( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_SETTINGS',
		payload: data
	}
}



// WEBPACK FOOTER //
// ./redux/actions/page.jsx